import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AuthSuccess from './pages/AuthSuccess';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import RealDashboardPage from './pages/RealDashboardPage';
import RealLogin from './pages/RealLogin';
import RealOrderPage from './pages/RealOrderPage';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="app-shell">
          <Navbar />
          <main className="app-main">
            <Routes>
              <Route path="/" element={<RealLogin />} />
              <Route path="/login" element={<RealLogin />} />
              <Route path="/real/login" element={<RealLogin />} />
              <Route path="/auth/success" element={<AuthSuccess />} />
              <Route path="/real" element={<ProtectedRoute><RealDashboardPage /></ProtectedRoute>} />
              <Route path="/real/order" element={<ProtectedRoute><RealOrderPage /></ProtectedRoute>} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
